import SubscriptionTable from 'components/Subscription';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';
import './index.scss';

export const Subscription = () => {

	const fetchedUserPermission = useSelector(
		(state: any) => state?.userProfile?.data?.permissions
	);
	const isSubscriptionPermission = checkPermission(fetchedUserPermission, {
		permissionName: 'Subscription',
		permission: ['view'],
	});

	return (
		<div>

			{isSubscriptionPermission && <SubscriptionTable />}
		</div>
	);
};
